<template>
  <div class="page-table musteriTanim  mainDiv mb-30" id="affix-container">
    <div class="animated fadeInUp card-base baslikBg">Yapı Ruhsat Tanımla</div>
    <el-row :gutter="10" v-loading="loading || addLoading"
            :element-loading-text='loading ? "Yükleniyor" : addLoading ? "Veriler Ekleniyor. Lütfen Bekleyiniz." : ""'
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-form status-icon :model="arsaForm" ref="arsaForm" class="demo-ruleForm">
        <el-col :lg="24" :md="24" :sm="24" :xs="24">
          <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft pb-20 pt-20">
            <el-row>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Yatırımcı" prop="musteri">
                  <el-select style="padding-bottom: 0; width: 100%" size="small"
                             v-model="arsaForm.musteriID" placeholder="Yatırımcı Seçiniz" filterable
                             :filter-methos="filterMethod" @change="getMusteriProjeleri">
                    <el-option v-for="item in arsaForm.musteriList" :key="item.musteriID"
                               :label="item.musteriAdi" :value="item.musteriID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Yatırımlar" prop="proje">
                  <el-select style="padding-bottom: 0; width: 100%" size="small" v-model="arsaForm.projeID"
                             placeholder="Yatırım Seçiniz" filterable
                             :filter-methos="filterMethod">
                    <el-option v-for="item in projeler" :key="item.id"
                               :label="item.projeBaslik" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <FileUploadArsa v-if="show" :key="count" :tahsisList="formFileList" :projeID="arsaForm.projeID"
                          :makeParamForService="serviceParamWrapper" :asyncFileUploader="asyncFileUploader"
                          service="ruhsatService"/>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import FileUploadArsa from '../../../components/FileUploadArsa.vue';
import notification from '../../../notification';
import ruhsatService from "@/WSProvider/RuhsatService";
import musteriService from "@/WSProvider/MusteriService";
import evrakService from "@/WSProvider/EvrakService";

export default {
  name: "YapiRuhsatTanimla",
  components: {FileUploadArsa},
  data() {
    return {
      sunucuDosyaSearch: '',
      dosyaYukleEvrakData: {
        yaziIsleriID: '',
        dosyaID: '',
        dosyaAdi: '',
      },
      sunucuDosyaList: [],
      initialSunucuDosyaList: [],
      dialogVisible: false,
      show: false,
      count: 0,
      projeler: [],
      formFileList: [],
      formFileListDefault: [
        {
          title: 'Bölge Müdürlüğüne Hitaben dilekçe',
          id: 'bolgeMudurluguDilekce',
        },
        {
          title: 'İmar Durumu (OSB den)',
          id: 'imarDurumu',
        },
        {
          title: 'Yol Kotu Belgesi (OSB onaylı)',
          id: 'yolKotuBelgesi',
        },
        {
          title: 'Aplikasyon Krokisi (OSB den 2.000,00-TL)',
          id: 'aplikasyokKrokisi',
        },
        {
          title: 'ÇED Raporu (İl Çevre ve Orman Müdürlüğü)',
          id: 'cedRaporu',
        },
        {
          title: 'Jolojik Etüt Raporu',
          id: 'jolojikRaporu',
        },
        {
          title: 'Zemin Etüt Raporu',
          id: 'zeminRaporu',
        },
        {
          title: 'Mimari Proje',
          id: 'mimariProje',
        },
        {
          title: 'Statik Proje ve Hesapları',
          id: 'statikProjeHesaplari',
        },
        {
          title: 'Elektrik Proje ve Hesapları',
          id: 'elektrikProjeHesaplari',
        },
        {
          title: 'Tesisat (Sıhhi, Kalorifer, Yangın ve Isı Yalıtım) Proje ve Hesapları',
          id: 'tesisatProjeHesaplari',
        },
        {
          title: 'Yapı Aplikasyon Krokisi (HUS)',
          id: 'yapiAplikasyonKrokisi',
        },
        {
          title: 'Yapı Denetim Kuruluşu İle Katılımcı Arasında Yapılan Sözleşme',
          id: 'denetimKurulusuIleKatilimciSozlesmesi',
        },
        {
          title: 'Katılımcı İle Müteahhit Arasında Yapılan Sözleşme',
          id: 'katilimciIleMuteahhitSozlesmesi',
        },
        {
          title: 'Müteahhit İle Şantiye Şefi Arasında Yapılan Sözleşme',
          id: 'muteahhitIleSantiyeSefiSozlesmesi',
        },
        {
          title: 'Ruhsat Harcı (7.000.00 TL. +4,50 * Kapalı Alan)',
          id: 'ruhsatHarci',
        },
      ],
      addLoading: false,
      loading: false,
      arsaForm: {
        evrakID: '',
        evrakAdi: '',
        evrakTarihi: '',
        kurumID: "",
        gelen: "",
        giden: "",
        kurumDurumu: '',
        durum: '1',
        musteriID: "",
        projeID: "",
        musteriList: [],
      },
    }
  },
  beforeDestroy() {
    this.$store.commit('setYapiUpdateData', null)
  },
  mounted() {
    this.getMusteriList()
    if (this.storeUpdateData.musteriID != null) {
      this.arsaForm.musteriID = this.storeUpdateData.musteriID
      this.getMusteriProjeleri(this.storeUpdateData.musteriID)
    }
    if (this.storeUpdateData.projeID != null) this.arsaForm.projeID = this.storeUpdateData.projeID
  },
  computed: {
    storeUpdateData() {
      return this.$store.getters.getArsaUpdateData
    },
    getMusteriID() {
      return this.arsaForm.musteriID
    },
    getProjeID() {
      return this.arsaForm.projeID
    },
  },
  watch: {
    getMusteriID(newVal) {
      this.show = false
      this.arsaForm.projeID = ''
      this.formFileList = []
    },
    async getProjeID() {
      try {
        this.formFileList = []
        this.formFileListDefault = [
          {
            title: 'Bölge Müdürlüğüne Hitaben dilekçe',
            id: 'bolgeMudurluguDilekce',
          },
          {
            title: 'İmar Durumu (OSB den)',
            id: 'imarDurumu',
          },
          {
            title: 'Yol Kotu Belgesi (OSB onaylı)',
            id: 'yolKotuBelgesi',
          },
          {
            title: 'Aplikasyon Krokisi (OSB den 2.000,00-TL)',
            id: 'aplikasyokKrokisi',
          },
          {
            title: 'ÇED Raporu (İl Çevre ve Orman Müdürlüğü)',
            id: 'cedRaporu',
          },
          {
            title: 'Jolojik Etüt Raporu',
            id: 'jolojikRaporu',
          },
          {
            title: 'Zemin Etüt Raporu',
            id: 'zeminRaporu',
          },
          {
            title: 'Mimari Proje',
            id: 'mimariProje',
          },
          {
            title: 'Statik Proje ve Hesapları',
            id: 'statikProjeHesaplari',
          },
          {
            title: 'Elektrik Proje ve Hesapları',
            id: 'elektrikProjeHesaplari',
          },
          {
            title: 'Tesisat (Sıhhi, Kalorifer, Yangın ve Isı Yalıtım) Proje ve Hesapları',
            id: 'tesisatProjeHesaplari',
          },
          {
            title: 'Yapı Aplikasyon Krokisi (HUS)',
            id: 'yapiAplikasyonKrokisi',
          },
          {
            title: 'Yapı Denetim Kuruluşu İle Katılımcı Arasında Yapılan Sözleşme',
            id: 'denetimKurulusuIleKatilimciSozlesmesi',
          },
          {
            title: 'Katılımcı İle Müteahhit Arasında Yapılan Sözleşme',
            id: 'katilimciIleMuteahhitSozlesmesi',
          },
          {
            title: 'Müteahhit İle Şantiye Şefi Arasında Yapılan Sözleşme',
            id: 'muteahhitIleSantiyeSefiSozlesmesi',
          },
          {
            title: 'Ruhsat Harcı (7.000.00 TL. +4,50 * Kapalı Alan)',
            id: 'ruhsatHarci',
          },

        ]
        this.loading = true
        if (this.getProjeID === undefined || this.getProjeID === null) return
        let response = await ruhsatService.ruhsatDetay(this.getMusteriID, this.getProjeID)
        this.formFileList = this.formFileListDefault.map(form => {
          if (response.data === undefined) return form
          let file = response.data.find(x => x.baslik === form.id)
          if (file) {
            return {
              ...form,
              file: [file]
            }
          } else {
            return form
          }
        }) || []
        this.show = true
        this.loading = false
        this.count++
      } catch (error) {
        this.loading = false
      }
    },
  },
  methods: {
    getSunucuDosyaList() {
      evrakService.sunucuDosyaList().then((response) => {
        if (response.status == 200) {
          localStorage.setItem("userDataDemirag", response.token);
          this.sunucuDosyaList = response.data;
          this.initialSunucuDosyaList = response.data;
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.sunucuDosyaList = [];
            this.initialSunucuDosyaList = [];
          } else notification.Status("errorMsg", this, error.errMsg)
        }
      })
    },
    getMusteriProjeleri(val) {
      musteriService.musteriProjeleri(0, val, 1).then((response) => {
        localStorage.setItem("userDataBGSurec", response.token)
        this.projeler = response.data;
        if (this.storeUpdateData.projeID != null) this.arsaForm.projeID = this.storeUpdateData.projeID
      }).catch(err => {
        this.projeler = []
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 400) {
            notification.Status("warning", this, "Bu müşterinin projesi bulunmamaktadır.")
          }
          if (error.status == 401) {
            notification.Status(150, this);
          }
        }
      })
    },
    asyncFileUploader: ruhsatService.createRuhsatFiles,
    serviceParamWrapper(item) {
      return {
        musteriID: this.arsaForm.musteriID,
        projeID: this.arsaForm.projeID,
        belge: item.file[0],
        baslik: item.id,
        updateID: item.updateID
      }
    },
    getMusteriList() {
      try {
        this.loading = true;
        ruhsatService.musteriListele(1, 0, 10000).then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token)
            this.arsaForm.musteriList = response.data
          }
          this.loading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.arsaForm.musteriList = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          }
          this.loading = false;
        })
      } catch (e) {
        this.loading = false;
      }
    },
    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    },
  }
}

</script>